import React, {useCallback} from 'react';
import I18n from 'app/i18n';
import {PopupDialog} from 'app/utils/modals/PopupDialog';
import PromoMoneyInterface from 'app/interfaces/PromoMoneyInterface';
import {modalsStore} from 'app/store/global';
import PromoMoneyCard from './PromoMoneyCard';

interface PopupPromoMoneyProps {
    promoMoney: PromoMoneyInterface;
    popupId: string;
}

const PopupPromoMoney = ({promoMoney, popupId}: PopupPromoMoneyProps): React.ReactElement => {
    const handleClose = useCallback(() => {
        modalsStore.hideModal(popupId);
    }, [popupId]);

    return (
        <PopupDialog id={popupId} setFocus>
            <div className="popup__content">
                <div className="bonuses-congratulation">
                    <h3 className="bonuses-congratulation__title">{I18n.t('promo_money_received')}</h3>
                    <div className="bonuses-congratulation__content">
                        <PromoMoneyCard amount={promoMoney.amount}/>
                        <button
                            className="button-adaptive bonuses-congratulation__button"
                            onClick={handleClose}
                        >
                            {I18n.t('ok')}
                        </button>
                    </div>
                    <div className="bonuses-congratulation__background">
                        <div className="bonuses-congratulation__line"></div>
                        <div className="bonuses-congratulation__semi-spehere-wrapper">
                            <div className="bonuses-congratulation__semi-spehere"></div>
                        </div>
                    </div>
                </div>
            </div>
        </PopupDialog>
    );
};

export default PopupPromoMoney;
